<template>
    <div id="carouselSectors" class="carousel slide carousel-fade" data-ride="carousel">
        <div class="carousel-inner">
            <div class="carousel-item" v-for="(sector, index) in sectores" :class="{active: index === 0}">
                <div class="row">
                    <div v-for="s in sector" class="col-md-6">
                        <div class="category" :style="{backgroundColor: color(s)}">
                            <img :src="'/images/icons/'+s+'-white.svg'" class="img-fluid" height="100">
                            <h3>{{ s }}</h3>
                            <a :href="'/sectors/'+s">
                                Ver Detalle
                                <i class="material-icons">arrow_forward</i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <a class="carousel-control-prev" href="#carouselSectors" role="button" data-slide="prev">
            <i class="material-icons">arrow_back</i>
            <span class="sr-only">Anterior</span>
        </a>
        <a class="carousel-control-next" href="#carouselSectors" role="button" data-slide="next">
            <i class="material-icons">arrow_forward</i>
            <span class="sr-only">Siguiente</span>
        </a>
    </div>
</template>

<script>
    import * as d3 from 'd3';
    import axios from 'axios';
    import _ from 'lodash';

    export default {
        data: function () {
            return {
                input: {
                    periodos: [],
                    sectores: []
                },
                loading: false,
                data: [],
                dimensions: {ordinal: ['sector'], time: ['periodo']},
                url: '/api/v1/data/pagos?group-by=' + JSON.stringify(['periodo', 'sector'])
            }
        },
        computed: {
            periodos: function () {
                return _(this.data)
                    .uniqBy('periodo')
                    .map(d => {
                        return d.periodo
                    })
                    .value();
            },
            sectores: function () {
                return _(this.data)
                    .uniqBy('sector')
                    .map(d => {
                        return d.sector
                    })
                    .value()
                    .reduce(function (result, value, index, array) {
                        if (index % 2 === 0)
                            result.push(array.slice(index, index + 2));
                        return result;
                    }, []);
            },
            color: function () {
                return d3.scaleOrdinal(['#081D58', '#3455DB', '#28A228', '#FE5A1D', '#D53E4F', '#49006A', '#FFD152', '#8F8F8F']);
            }
        },
        methods: {
            refreshData: function () {
                this.loading = true;
                axios.get(this.url)
                    .then((response) => {
                        this.loading = false;

                        this.data = _(response.data)
                            .filter(d => {
                                return d.sector !== null
                            })
                            .value();
                        //Normalizamos los valores
                        const totals = _(this.data)
                            .groupBy('periodo')
                            .mapValues(d => {
                                return _.sumBy(d, 'sum')
                            })
                            .value();

                        _(this.data)
                            .forEach(d => {
                                d.sum = d.sum / totals[d.periodo];
                            })
                    })
            },
            detailClicked: function (d) {
                window.location.href = '/sectors/' + d.key;
            }
        },
        mounted: function () {
            this.refreshData();
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/HomeSectors.vue